"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PQA_STAGE_KEY = void 0;
exports.getAemInstanceKey = getAemInstanceKey;
exports.isPQAAuthStage = isPQAAuthStage;
var _cicUtils = require("@eon-funke/cic-utils");
var PQA_STAGE_KEY = exports.PQA_STAGE_KEY = 'PQA';
function isPQAAuthStage() {
  // TODO - check for altervnative approaches for checking the instance (considering security)
  return (window.location.hostname || '').toLowerCase().includes('ycsncs-aem02');
}
function getAemInstanceKey() {
  return _cicUtils.EnvironmentHelper.getAemInstanceKey() || null;
}